import Validate from "Components/GMS/Pdw/upload/Validate";
import React from "react";
import Dialog from "Components/DesignSystem/Dialog/Dialog";

/**
 * "Upload XLS - Validate" / "Validate XLS" (CBM) — a dry run that reports what a
 * file WOULD do. Used from the Products list and the Rules CBM matrix. On DS
 * `Dialog` since § 126.
 */
const ValidatePDW = (props) => {
  return (
    <Dialog
      isOpen={!!props.showValidatePopup}
      onClose={props.modalValidateClose}
      closeOnOutsideClick
      title={props?.type === "CBM" ? "Validate XLS" : "Upload XLS - Validate"}
      data-testid="pdw-products-validate-dialog"
    >
      <Validate
        modalValidateClose={props.modalValidateClose}
        ruleId={props.ruleId}
        type={props.type}
        compatibilityLevel={props.compatibilityLevel}
        fetchData={props.fetchData}
      />
    </Dialog>
  );
};

export default ValidatePDW;
